import * as React from 'react';
import { TextInput } from 'soprasteria-ui-library';
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { formatAddress } from '../../../../helpers/AddressHelper';

interface IOrthodonticReferralOrthodontistInformation {
    orthodonticReferral: IOrthodonticReferral;
}

export const OrthodonticReferralOrthodontistInformation: React.FunctionComponent<IOrthodonticReferralOrthodontistInformation> = ({ orthodonticReferral }) => {

    return (
        <>
            {
                orthodonticReferral.orthodontistCareProvider ?
                    <>
                        <div className={`row readonly-less-margin`}>
                            <h5 className="col-12">Vårdansvarig</h5>
                            <div className="col-6">
                                <TextInput name="readonlyOrthodontistOrganisationNumber" label="Vårdgivare" defaultValue={orthodonticReferral.orthodontistCareProvider.displayOrganisationInformation} inlineLabel readonly />
                            </div>
                            <div className="col-6">
                                <TextInput name="readonlyOrthodontistName" label="Mottagning" defaultValue={orthodonticReferral.orthodontistCareProvider.displayCareProviderName} inlineLabel readonly />
                            </div>
                            <div className="col-6">
                                <TextInput name="readonlyOrthodontistAddress" label="Adress" defaultValue={formatAddress(orthodonticReferral.orthodontistCareProvider?.address)} inlineLabel readonly />
                            </div>
                            <div className="col-6">
                                <TextInput name="readonlyOrthodontistEmail" label="E-post" defaultValue={orthodonticReferral.orthodontistCareProvider?.address?.emailAddress ?? "Saknas"} inlineLabel readonly />
                            </div>
                            <div className="col-6">
                                <TextInput name="readonlyOrthodontistPhoneNumber" label="Telefonnummer" defaultValue={orthodonticReferral.orthodontistCareProvider?.address?.phoneNumber ?? "Saknas"} inlineLabel readonly />
                            </div>
                        </div>
                        <hr />
                    </>
                    : null}
        </>
    )
}